package com.devi3east.bashbuddy.common.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class Address(
    val line1: String,
    val city: String,
    val state: String,
    val zipCode: String,
    val latitude: Double? = null,
    val longitude: Double? = null
)